import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { css } from 'aphrodite';
import shortid from 'shortid';

import Translatable from '../../../../../../../components/Translatable';
import Fieldset from './Fieldset';

import styles from './styles.js';

import { createFiltersQueryStringFromObject } from '../../../../../../../methods';

class PanelLarge extends Component {
    static propTypes = {
        apiUrl: PropTypes.string.isRequired,
        applyFilterGroupCollection: PropTypes.func.isRequired,
        fetchSearchResults: PropTypes.func.isRequired,
        filterGroupCollection: PropTypes.object.isRequired,
        filterGroupCollectionIndex: PropTypes.number.isRequired,
        handleActiveFilterGroupCollection: PropTypes.func.isRequired,
        lang: PropTypes.object.isRequired,
        searchParams: PropTypes.object.isRequired,
        trackingCookieId: PropTypes.number.isRequired,
        userLang: PropTypes.string.isRequired
    }

    state = {
        filterGroupCollection: this.props.filterGroupCollection,
        expandedGroups: [],
        hasChanged: false,
        isCancelled: false
    }

    componentWillUnmount() {
        const { applyFilterGroup } = this;
        applyFilterGroup();
    }

    applyFilterGroup = () => {
        const { filterGroupCollection, hasChanged, isCancelled } = this.state;
        const {
            apiUrl,
            applyFilterGroupCollection,
            fetchSearchResults,
            filterGroupCollectionIndex,
            searchParams,
            trackingCookieId,
            userLang
        } = this.props;
        if (!isCancelled && hasChanged) {
            applyFilterGroupCollection(filterGroupCollection, filterGroupCollectionIndex);
            const location = decodeURIComponent(window.location.pathname.split('/')[4]);
            const tag = {
                quick_slug: decodeURIComponent(window.location.pathname.split('/')[3])
            };
            const paramsQs = createFiltersQueryStringFromObject(searchParams, filterGroupCollection);
            fetchSearchResults(apiUrl, userLang, location, tag, paramsQs, trackingCookieId);
        }
    }

    handleApplyFilters = () => {
        const { filterGroupCollectionIndex, handleActiveFilterGroupCollection } = this.props;
        handleActiveFilterGroupCollection(filterGroupCollectionIndex);
    }

    handleCancelFilters = () => {
        const { handleActiveFilterGroupCollection } = this.props;
        this.setState(() => ({
            isCancelled: true
        }), handleActiveFilterGroupCollection);
    }

    handleFilterChange = event => {
        const { filterGroupCollection } = this.state;
        const filterIndex = event.target.dataset.filterIndex;
        const filterGroupIndex = event.target.dataset.filterGroupIndex;
        const inputType = event.target.dataset.inputType;
        let value;
        if (inputType === 'checkbox') {
            value = event.target.checked;
        } else if (inputType === 'radio') {
            value = event.target.checked;
        } else if (inputType === 'increment') {
            value = Number(event.target.dataset.value);
        } else if (inputType === 'toggle-switch') {
            value = event.target.checked;
        } else if (inputType === 'dropdown') {
            value = Number(event.target.value);
        }
        const updatedFilter = {
            ...filterGroupCollection.filterGroups[filterGroupIndex].filters[filterIndex],
            data: {
                ...filterGroupCollection.filterGroups[filterGroupIndex].filters[filterIndex].data,
                value
            }
        };
        const filters = filterGroupCollection.filterGroups[filterGroupIndex].filters.map(
            (filter, index) => {
                if (Number(index) !== Number(filterIndex)) {
                    return filter;
                }
                return {
                    ...filter,
                    ...updatedFilter
                };
            }
        );
        const filterGroups = filterGroupCollection.filterGroups.map((filterGroup, index) => {
            if (Number(index) !== Number(filterGroupIndex)) {
                return filterGroup;
            }
            return {
                ...filterGroup,
                filters
            };
        });
        this.setState((prevState) => ({
            ...prevState,
            filterGroupCollection: {
                ...filterGroupCollection,
                filterGroups
            },
            hasChanged: true
        }));
    }

    handleExpand = (expandedIndex, classId = 0) => {
        const { expandedGroups } = this.state;
        let updatedExpandedGroups = [];
        if (expandedGroups.filter(e => Number(e.index) === Number(expandedIndex)).length) {
            updatedExpandedGroups = expandedGroups.filter(e => Number(e.index) !== Number(expandedIndex));
        } else {
            updatedExpandedGroups.push({
                index: expandedIndex,
                classId
            });
        }
        this.setState({ expandedGroups: updatedExpandedGroups });
    }

    handleExpanded = (expandedIndex, classId) => {
        const { expandedGroups } = this.state;
        const updatedExpandedGroups = expandedGroups.map(group => {
            if (group.index !== expandedIndex) {
                return group;
            }
            return {
                ...group,
                classId
            };
        });
        this.setState({ expandedGroups: updatedExpandedGroups });
    }

    render() {
        const {
            handleApplyFilters,
            handleCancelFilters,
            handleFilterChange,
            handleExpand,
            handleExpanded
        } = this;
        const { filterGroupCollectionIndex, lang } = this.props;
        const { expandedGroups, filterGroupCollection } = this.state;
        const { filterGroups } = filterGroupCollection;
        return (
            <div
                role="menu"
                className={css(styles.panel, styles.panel_sixty, styles.visible)}
            >
                <div>
                    <div>
                        {filterGroups.map((filterGroup, filterGroupIndex) => (
                            <Fieldset
                                key={shortid.generate()}
                                classId={
                                    expandedGroups.filter(i =>
                                        i.index === filterGroupIndex).length ?
                                        expandedGroups.find(i =>
                                            i.index === filterGroupIndex).classId : 0
                                }
                                expandedGroups={expandedGroups}
                                filterGroup={filterGroup}
                                filterGroupIndex={filterGroupIndex}
                                filterGroupCollectionIndex={filterGroupCollectionIndex}
                                handleFilterChange={handleFilterChange}
                                handleExpand={handleExpand}
                                handleExpanded={handleExpanded}
                                isFullScreenPanel
                                lang={lang}
                            />
                        ))}
                    </div>
                    <div style={{ marginTop: '83px' }}>
                        <div className={css(styles.containerFixed)}>
                            <div style={{ marginBottom: '8px' }}>
                                <div className={css(styles.textright)}>
                                    <div
                                        className={css(styles.inlineBlock)}
                                        style={{ marginRight: '16px' }}
                                    >
                                        <span>
                                            <div className={css(styles.textExtra)}>
                                                <button
                                                    type="button"
                                                    className={css(styles.cancelButton)}
                                                    aria-disabled="false"
                                                    aria-busy="false"
                                                    onClick={handleCancelFilters}
                                                >
                                                    <Translatable
                                                        content={{
                                                            transKey: 'common.cancel'
                                                        }}
                                                    />
                                                </button>
                                            </div>
                                        </span>
                                    </div>
                                    <span>
                                        <button
                                            type="button"
                                            className={css(styles.applyButton)}
                                            aria-busy="false"
                                            onClick={handleApplyFilters}
                                        >
                                            <span className={css(styles.applyButtonText)}>
                                                <Translatable
                                                    content={{
                                                        transKey: 'common.apply'
                                                    }}
                                                />
                                            </span>
                                        </button>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default PanelLarge;



// WEBPACK FOOTER //
// ./src/pages/Search/Main/FilterBar/FilterGroupCollection/Panels/PanelLarge/PanelLarge.jsx